module.exports = ".rapportoStileCheckbox{\n\tpadding-left: 25px;\n\theight: 25px;\n}\n"